import { MouseEvent } from "react";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import LinkOutIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LinkOutIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import styles from "./LinkListItem.module.css";

type LinkListItemProps = {
  url: string;
  onLinkClick: (url: string) => void;
};

export function LinkListItem({ url, onLinkClick }: LinkListItemProps) {
  const { t } = useTranslation();

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    onLinkClick(url);
  };

  return (
    <div className={styles["link"]}>
      <FixaButton
        iconOnly
        ssrIcon={LinkOutIconPath}
        onClick={handleClick}
        size="small"
        aria-label={`${t("openLinkString")} ${url}`}
      />
      <a
        className={styles["linkUrl"]}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
      >
        <FixaText textStyle="Label.M">{url}</FixaText>
      </a>
    </div>
  );
}
